import React, { useEffect, useState } from 'react';
import { BarChart3 } from 'lucide-react';
import toast from 'react-hot-toast';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import '../AppLinks/AppLinks.css';
import './HomeStats.css';

const FIELDS = [
    { key: 'activeProfiles', label: 'Active profiles', hint: 'Live: profiles that are switched on' },
    { key: 'verifiedMembers', label: 'Verified members', hint: 'Live: share of active profiles verified by the team' },
    { key: 'happyMarriages', label: 'Happy marriages', hint: 'Live: approved success stories' },
];

const HomeStats = () => {
    const [mode, setMode] = useState('manual');
    const [manual, setManual] = useState({ activeProfiles: '', verifiedMembers: '', happyMarriages: '' });
    const [live, setLive] = useState({});
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        API.get('/site-stats/admin')
            .then(res => { setMode(res.data.mode); setManual(res.data.manual); setLive(res.data.live); })
            .catch(() => toast.error('Failed to load the home page numbers'));
    }, []);

    const save = async event => {
        event.preventDefault();
        setSaving(true);
        try {
            await API.put('/site-stats/admin', { mode, ...manual });
            toast.success(mode === 'live' ? 'Saved. The home page now shows live numbers.' : 'Saved. The home page shows your typed numbers.');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to save');
        } finally { setSaving(false); }
    };

    return (
        <div className="applinks-layout">
            <Sidebar />
            <div className="admin-content applinks-content">
                <Navbar title={<span className="applinks-nav-title"><BarChart3 size={18} /> Home page numbers</span>} />
                <main className="applinks-page">
                    <header className="applinks-head">
                        <h1>Home page numbers</h1>
                        <p>The strip under the home page banner (website and mobile app). Type the numbers yourself, or let the site count them from real data.</p>
                    </header>

                    <form className="applinks-card" onSubmit={save}>
                        <div className="hs-modes" role="radiogroup" aria-label="Where the numbers come from">
                            {[['manual', 'Manual', 'Show the numbers I type below'], ['live', 'Live from server', 'Count the real numbers automatically']].map(([value, title, text]) => (
                                <button type="button" key={value} role="radio" aria-checked={mode === value} className={mode === value ? 'is-on' : ''} onClick={() => setMode(value)}>
                                    <strong>{title}</strong><span>{text}</span>
                                </button>
                            ))}
                        </div>

                        {FIELDS.map(field => (
                            <label className="applinks-field" key={field.key}>
                                <span>{field.label}</span>
                                <div className="applinks-input">
                                    <input
                                        value={manual[field.key] || ''}
                                        maxLength={20}
                                        disabled={mode === 'live'}
                                        placeholder="e.g. 50K+"
                                        onChange={event => setManual(current => ({ ...current, [field.key]: event.target.value }))}
                                    />
                                    <b className="hs-live" title="What live mode shows right now">Live now: {live[field.key] ?? '…'}</b>
                                </div>
                                <small className="applinks-state">{mode === 'live' ? field.hint : 'Shown exactly as typed'}</small>
                            </label>
                        ))}

                        <p className="hs-note">The fourth box, “Private – Secure by design”, is a fixed promise and is not a number, so it always stays the same.</p>
                        <div className="applinks-actions"><button type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button></div>
                    </form>
                </main>
            </div>
        </div>
    );
};

export default HomeStats;
